﻿export class FileName {
  private fileName: string

  constructor(fileName: string) {
    this.fileName = fileName;
  }

  public withExtension(): string | null {
    if (this.fileName === undefined)
      return null;

    return this.fileName;
  }

  public withoutExtension(): string | null {
    if (this.fileName === undefined)
      return null;

    return this.fileName.substring(0, this.fileName.lastIndexOf('.'));
  }

  public extension(): string | null {
    if (this.fileName === undefined)
      return null;

    return this.fileName.substring(this.fileName.lastIndexOf('.') + 1).toLowerCase();
  }
}

export default FileName;